module.exports = __webpack_public_path__ + "static/media/trophy-01.3da6880f.jpg";